import type {ReactElement} from 'react';
import {Text, TextSize, TextType} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {ClickableDiv} from '@Components/clickable-div';
import {StockPanelMessage} from '@Panels/stock-panel/components/stock-panel-message/stock-panel-message';
import styles from './stock-panel-error.module.scss';
import type {StockPanelErrorProps} from './stock-panel-error.types';

function StockPanelError({...props}: StockPanelErrorProps): ReactElement {
  const getRefreshButton = (): ReactElement | null => {
    if (!props.onRefresh) {
      return null;
    }
    return (
      <ClickableDiv className={styles.refreshButton} onClick={props.onRefresh}>
        <Icon className={styles.refreshButtonIcon} icon="icon-refresh" size={IconSize.SIZE_ICON_16} type={IconType.NONE} shape={IconShape.NONE} />
        <span className={styles.refreshButtonText}>{window.i18next.t('pmwjs_refresh')}</span>
      </ClickableDiv>
    );
  };

  return (
    <StockPanelMessage icon="icon-exclamation-triangle" className={props.className}>
      <Text className="content-body text-center" val={props.text} type={TextType.BODY} size={TextSize.MD} />
      {getRefreshButton()}
    </StockPanelMessage>
  );
}

export default StockPanelError;
